// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"346":"stores","818":"auth"}[chunkId] || chunkId) + "-legacy." + {"74":"cbe2f553","346":"cb972bad","818":"dcecb0b8"}[chunkId] + ".js";
};